"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ValidationError_1 = __importDefault(require("./ValidationError"));
const getValidationErrors_1 = __importDefault(require("./getValidationErrors"));
async function validate(schema, doc, passedOptions = {}, ...args) {
    const validationErrors = await (0, getValidationErrors_1.default)(schema, doc, passedOptions, ...args);
    if (validationErrors) {
        throw new ValidationError_1.default(validationErrors);
    }
}
exports.default = validate;
